import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Subscription } from "rxjs";

@Pipe({
  name: "authImage",
  standalone: true,
  pure: false,
})
export class AuthImagePipe implements PipeTransform, OnDestroy {
  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);
  private cd = inject(ChangeDetectorRef);

  private currentUrl: string | null = null;
  private objectUrl: string | null = null;
  private safeUrl: SafeUrl | null = null;
  private subscription: Subscription | null = null;

  transform(url: string | null | undefined): SafeUrl | null {
    if (!url) return null;
    if (url === this.currentUrl) return this.safeUrl;

    this.cleanup();
    this.currentUrl = url;

    this.subscription = this.http
      .get(url, { responseType: "blob" })
      .subscribe((blob) => {
        this.objectUrl = URL.createObjectURL(blob);
        this.safeUrl = this.sanitizer.bypassSecurityTrustUrl(this.objectUrl);
        this.cd.markForCheck();
      });

    return null;
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  private cleanup(): void {
    this.subscription?.unsubscribe();
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
    this.objectUrl = null;
    this.safeUrl = null;
    this.currentUrl = null;
    this.subscription = null;
  }
}
